import React from 'react';
import { Collapse } from 'reactstrap';

const Container = ({ children, className, group, icon, title, onSelectAsset, startsExpanded, isDependency }) => {

  const [expanded, setExpanded] = React.useState(group ? startsExpanded : true);

  const buttonIcon = expanded ? "fa-chevron-down" : "fa-chevron-right";

  return (
    <div className={`${className} vis-container`}>
      <div className='header'>
        <button
          aria-expanded={expanded}
          className='btn btn-sm py-0 px-1'
          onClick={() => setExpanded(!expanded)}
          type='button'
        >
          <span className={`fa fa-fw ${buttonIcon}`}></span>
        </button>
        <a
          className={`${isDependency ? "dependency" : ""} container-title`}
          onClick={group ? () => onSelectAsset(group, group.dependencies, group.dependents) : null}
        >
          <span className={`fa fa-fw ${icon} mx-1`}></span>
          { title }
        </a>
      </div>
      <Collapse isOpen={expanded}>
        <div className='nested'>
          { children }
        </div>
      </Collapse>
    </div>
  );
};

export default Container;
